import { memo } from 'react';
import { useMeta } from 'hoofd';
import type { MetaOptions } from 'hoofd';

export const MetaContent = memo((props: MetaOptions) => {
    useMeta(props);
    return null;
});
